export default __webpack_public_path__ + "static/Clarendon_Hotel_8-7581fe125e31c769db273db8a227d2bb.jpg";